
<div id="dialog" class="fixed top-0 left-0 h-dvh w-dvw z-50 cursor-default" #view (click)="phrases[this.currentStep].showSkip && completed()">
@if (phrases[this.currentStep].showSkip) {
		<app-comment class="absolute left-1/2 bottom-16 transform -translate-x-1/2">Нажми,&nbsp;чтобы&nbsp;продолжить</app-comment>
} @else {
	<div class="w-full max-w-[1200px] p-6 pb-5 md:pb-2 sm:px-8 sm:pb-4 md:px-24 md:pb-12 flex items-end justify-center min-h-full m-auto">
		<app-dialog class="w-[800px] min-h-26 flex align-stretch" [rotate]="1" [hidePaperClip]="true" [disableLoadSound]="true">
			<div class="absolute top-0 left-12 py-1 px-3 md:py-3 md:px-8 z-3 transform -translate-y-1/2">
				<div class="w-full h-full absolute top-0 left-0 border-2 border-(--custom-color-1) rounded-md rotate-[-2deg] shadow-(--custom-bottom-shadow) bg-(--custom-color-2)"></div>
				<span class="relative text-sm/[110%] md:text-2xl/8 font-medium font-(family-name:--default-font-family2) text-(--custom-color-1) whitespace-nowrap select-none">{{name}}</span>
			</div>
			<div class="select-none pointer-events-none font-(family-name:--default-font-family2) text-base/[130%] md:text-[20px]/[130%] pt-3 md:pt-unset block text-(--custom-color-1)">
				<div appShowByLetter [text]="phrases[currentStep].desc" [speed]="3" (phraseEnded)="stopSound()"  (completed)="completed()"></div>
			</div>
			<div class="absolute z-9 right-4 bottom-4 cursor-pointer select-none">
				<img class="size-4 select-none" src="./assets-compressed/categories/icons/arrow-right.svg" alt="next">
			</div>
		</app-dialog>
	</div>
}
</div>